import styled from 'styled-components';
import { DataGrid } from '@innovyze/stylovyze';

export const StyledDataGrid = styled(DataGrid)`
  & .failsafe-style {
    display: none !important;
  }
`;
